import { privateAxios } from 'services/api/privateAxios';

export const rejectOrder = id =>
  privateAxios({
    method: 'post',
    url: `/orderboard/reject/${id}`,
  });
